import React, { useState, useEffect } from 'react';
import { ThumbsUp, ThumbsDown, Check } from 'lucide-react';

interface FeedbackWidgetProps {
    postId: string;
}

const FeedbackWidget: React.FC<FeedbackWidgetProps> = ({ postId }) => {
    const [feedback, setFeedback] = useState<'positive' | 'negative' | null>(null);
    const [submitted, setSubmitted] = useState(false);

    useEffect(() => {
        // Check if user already gave feedback
        const storedFeedback = localStorage.getItem(`feedback_${postId}`);
        if (storedFeedback) {
            setFeedback(storedFeedback as 'positive' | 'negative');
            setSubmitted(true);
        }
    }, [postId]);

    const handleFeedback = (type: 'positive' | 'negative') => {
        setFeedback(type);
        setSubmitted(true);
        localStorage.setItem(`feedback_${postId}`, type);

        // Here you could also send to analytics
        // analytics.track('article_feedback', { postId, type });
    };

    if (submitted) {
        return (
            <div className="my-8 p-6 bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl border border-green-200">
                <div className="flex items-center justify-center gap-3 text-green-700">
                    <Check className="w-6 h-6" />
                    <span className="font-medium">
                        Obrigado pelo seu feedback!
                        {feedback === 'positive' ? ' 😊' : ' Vamos melhorar!'}
                    </span>
                </div>
            </div>
        );
    }

    return (
        <div className="my-8 p-6 bg-gradient-to-r from-gray-50 to-gray-100 rounded-xl border border-gray-200">
            <div className="text-center">
                <h4 className="text-lg font-semibold text-gray-800 mb-4">
                    👍 Este artigo foi útil para você?
                </h4>
                <div className="flex justify-center gap-4">
                    <button
                        onClick={() => handleFeedback('positive')}
                        className="group flex items-center gap-2 px-6 py-3 bg-white rounded-lg border-2 border-gray-200 hover:border-green-500 hover:bg-green-50 transition-all duration-200"
                    >
                        <ThumbsUp className="w-5 h-5 text-gray-500 group-hover:text-green-600 transition-colors" />
                        <span className="font-medium text-gray-700 group-hover:text-green-700">Sim</span>
                    </button>
                    <button
                        onClick={() => handleFeedback('negative')}
                        className="group flex items-center gap-2 px-6 py-3 bg-white rounded-lg border-2 border-gray-200 hover:border-red-500 hover:bg-red-50 transition-all duration-200"
                    >
                        <ThumbsDown className="w-5 h-5 text-gray-500 group-hover:text-red-600 transition-colors" />
                        <span className="font-medium text-gray-700 group-hover:text-red-700">Não</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FeedbackWidget;
